import { ArrayUtil, FormatUtil } from 'helper-util';
import { getPermissionsFromStorage } from '../../services/clientConfigurationService';
import { getStringFromStorage } from '../../services/storageService';
import { activeClientConfig } from '../../services/authService';
import memoizeOne from 'memoize-one';
import isEqual from 'lodash/isEqual';

export const getFilteredPermissionMenu = (navBarConfig) => {
  const permissionList = getPermissionsFromStorage();

  return navBarConfig
    .map((config) => {
      let validSubMenu = (config.subMenu || []).filter((subMenu) => {
        const currentClientConfig = getStringFromStorage(activeClientConfig);
        const isPermissionFound = ArrayUtil.isEmpty(subMenu.permission)
          ? true
          : subMenu.permission.some((v) =>
              !ArrayUtil.isEmpty(permissionList) ? permissionList.includes(v) : false,
            );
        if (subMenu.hasOwnProperty('configSpecific')) {
          return subMenu.configSpecific.includes(currentClientConfig) ? isPermissionFound : false;
        }
        return isPermissionFound;
      });

      if (!validSubMenu.some((sMenu) => sMenu.isAggregate)) {
        validSubMenu = validSubMenu.filter((sMenu) => sMenu.id !== 'group');
      }

      if (config.subMenu && ArrayUtil.isEmpty(validSubMenu)) {
        return null;
      }
      if (!config.subMenu) {
        return config;
      } else {
        return {
          ...config,
          subMenu: validSubMenu,
        };
      }
    })
    .filter((config) => !!config);
};

export const getUserName = memoizeOne((user) => {
  if (!user) return '';

  const { email = '', firstName = '', lastName = '' } = user;
  let initials = email ? email[0] : '';
  if (firstName) initials = firstName[0];
  if (firstName && lastName) initials = firstName[0] + lastName[0];
  return FormatUtil.text.toUpperCase(initials);
}, isEqual);
